import { render, staticRenderFns } from "./IconPrint.vue?vue&type=template&id=721b03e2&"
var script = {}
import style0 from "./IconPrint.vue?vue&type=style&index=0&id=721b03e2&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports